import selectField from "./selectField";
import stringField from "./stringField";
import textField from "./textField";
import floatField from "./floatField";
import iconField from "./iconField";
import checkboxField from "./checkboxField";
import dateField from "./dateField";
import booleanField from "./booleanField";
import fileField from "./fileField";

export default {
  select: selectField,
  string: stringField,
  text: textField,
  float: floatField,
  icon: iconField,
  checkbox: checkboxField,
  date: dateField,
  boolean: booleanField,
  file: fileField,
};
